export default {"src":"/_next/static/image/public/images/flags/flag_52.6aa6aa9ad2cd10da28cc8a78454c11f3.svg","height":16,"width":24};